import { render, staticRenderFns } from "./dataPermission.vue?vue&type=template&id=39df0d06&scoped=true"
import script from "./dataPermission.vue?vue&type=script&lang=js"
export * from "./dataPermission.vue?vue&type=script&lang=js"
import style0 from "./dataPermission.vue?vue&type=style&index=0&id=39df0d06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39df0d06",
  null
  
)

export default component.exports